import React from 'react';
import { openNewWindow, reDirectPage, setDetailPageUrl } from '../../../../lib/common';
import Button from '../../../../components/Button';
import Anchor from '../../../../components/link/Anchor';
import TableFilterInput from '../../../../components/table/TableFilterInput';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import { EVENT_STATUS, EVENT_STATUS_TEXT } from '../../../../constants/service/app/eventConstants';
import { EVENT_EDIT_URL_PATH } from '../../../../constants/service/common/urlConstants';

/**
 *  홈에 노출중인 기획전 리스트 컬럼
 */
const columns = (data) => {
  const { filterOption, onFilter, getEventTagColumnTagList } = data;
  return [
    {
      Header: '수정',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="primary"
          text="수정"
          onClick={() => reDirectPage({ path: setDetailPageUrl(EVENT_EDIT_URL_PATH, row.original.id) })}
        />
      ),
    },
    {
      Header: '상품 보기',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Button
          isRadius
          color="gray"
          text="상품 보기"
          onClick={() => data.openEventItemListModal({ eventId: row.original.id })}
        />
      ),
    },
    {
      accessor: 'id',
      Header: '기획전 ID',
      fixed: 'left',
      width: 100,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(EVENT_EDIT_URL_PATH, row.value))}
        />
      ),
    },
    {
      accessor: 'status',
      Header: '상태',
      fixed: 'left',
      width: 100,
      Cell: (row) => EVENT_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'url',
      Header: '이미지',
      fixed: 'left',
      width: 100,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'mainTitle',
      Header: '제목',
      resizable: true,
      filterable: true,
      Cell: (row) => <div dangerouslySetInnerHTML={{ __html: row.value }} />,
      Filter: () => (
        <TableFilterInput option={filterOption.mainTitle} onFilter={(mainTitle) => onFilter({ mainTitle })} />
      ),
    },
    {
      accessor: 'contents',
      Header: '본문',
      resizable: true,
      filterable: false,
      width: 300,
    },
    {
      Header: '태그',
      width: 100,
      Cell: (row) =>
        row.original.isTagExists ? (
          <Anchor
            text="태그 보기"
            isUnderLine
            color="primary"
            onClick={() =>
              getEventTagColumnTagList({
                eventId: row.original.id,
              })
            }
          />
        ) : (
          '-'
        ),
    },
    {
      accessor: 'eventPeriod',
      Header: '기획전 기간',
      width: 320,
      Cell: (row) =>
        row.original.status === EVENT_STATUS.unlimited
          ? EVENT_STATUS_TEXT[row.original.status]
          : row.original.eventPeriod,
    },
  ];
};

export default columns;
